if (!customElements.get('sakaza-bundle-carousel')) {
  customElements.define('sakaza-bundle-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.cards = [...this.querySelectorAll('.sk-pdpbundle-slide')];
      this.index = 0;
      const stage = this.querySelector('[data-bundle-track]');
      this.querySelector('.sk-pdpbundle-controls').hidden = this.cards.length < 2;
      this.querySelector('[data-bundle-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-bundle-next]').addEventListener('click', () => this.show(this.index + 1));
      stage.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        this.gesture = { x: event.clientX, y: event.clientY, id: event.pointerId };
        this.suppressClick = false;
      });
      stage.addEventListener('pointermove', event => {
        if (!this.gesture || event.pointerId !== this.gesture.id) return;
        const dx = event.clientX - this.gesture.x;
        const dy = event.clientY - this.gesture.y;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) {
          this.suppressClick = true;
          stage.setPointerCapture(event.pointerId);
        }
      });
      stage.addEventListener('pointerup', event => {
        if (!this.gesture) return;
        const dx = event.clientX - this.gesture.x;
        const dy = event.clientY - this.gesture.y;
        this.gesture = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
          this.suppressClick = true;
          this.show(this.index + (dx < 0 ? 1 : -1));
        }
      });
      stage.addEventListener('pointercancel', () => { this.gesture = null; });
      stage.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; return; }
        const card = event.target.closest('.sk-pdpbundle-slide');
        if (card && !card.classList.contains('is-active')) {
          event.preventDefault();
          this.show(this.cards.indexOf(card));
        }
      });
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('.sk-pdpbundle-slide'));
        if (index >= 0) this.show(index);
      });
      this.show(0, false);
    }
    show(index, announce = true) {
      const total = this.cards.length;
      if (!total) return;
      this.index = (index + total) % total;
      this.cards.forEach((card, i) => {
        const active = i === this.index;
        card.classList.toggle('is-active', active);
        card.classList.toggle('is-prev', total > 2 && i === (this.index - 1 + total) % total);
        card.classList.toggle('is-next', total > 1 && i === (this.index + 1) % total);
        card.setAttribute('aria-hidden', String(!active));
        card.querySelectorAll('a').forEach(link => { link.tabIndex = active ? 0 : -1; });
      });
      if (announce) this.querySelector('[data-bundle-status]').textContent = `Product ${this.index + 1} of ${total}: ${this.cards[this.index].getAttribute('aria-label')}`;
    }
  });
}
